"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var inputUtils_1 = require("../../core/inputUtils");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps;
    var value = compData.value, placeholder = compData.placeholder, step = compData.step, label = compData.label;
    var useAmPmFormat = compProps.useAmPmFormat, controller = compProps.controller, initialTime = compProps.initialTime, readOnly = compProps.readOnly, isDisabled = compProps.isDisabled, required = compProps.required;
    return {
        value: value,
        placeholder: initialTime === 'none' ? '' : placeholder,
        step: step,
        label: label,
        useAmPmFormat: useAmPmFormat,
        controller: controller,
        initialTime: initialTime,
        readOnly: readOnly,
        isDisabled: isDisabled,
        required: required,
    };
});
var alignmentCssVars = function (alignment, labelPadding) {
    return __assign(__assign({ '--textAlign': alignment }, (alignment === 'right'
        ? {
            '--dir': 'rtl',
            '--arrowMargin': '0 0 0 20px',
            '--flexDirection': 'row-reverse',
        }
        : {
            '--dir': 'ltr',
            '--arrowMargin': '0 20px 0 0',
            '--flexDirection': 'row',
        })), (alignment === 'right'
        ? {
            '--labelPadding': "0 " + labelPadding + "px 0 0",
        }
        : alignment === 'center'
            ? {
                '--labelPadding': '0',
            }
            : {
                '--labelPadding': "0 0 0 " + labelPadding + "px",
            }));
};
var inputPaddingVar = function (alignment, isMobileView, margin) {
    if (margin === void 0) { margin = 15; }
    return isMobileView
        ? "0 " + margin + "px"
        : alignment === 'left'
            ? "0 0 0 " + margin + "px"
            : alignment === 'right'
                ? "0 " + margin + "px 0 0"
                : '0';
};
exports.css = withCompInfo_1.withCompInfo(['compLayout', 'compProps', 'compData', 'isMobileView'], function (_a, cssVars) {
    var compLayout = _a.compLayout, compProps = _a.compProps, compData = _a.compData, isMobileView = _a.isMobileView;
    var label = compData.label;
    var labelMargin = compProps.labelMargin, labelPadding = compProps.labelPadding, alignment = compProps.alignment, margin = compProps.margin;
    return __assign(__assign(__assign({}, cssVars), alignmentCssVars(alignment, labelPadding)), { '--labelMarginBottom': !label ? '0' : labelMargin + "px", '--inputPadding': inputPaddingVar(alignment, isMobileView, margin), '--inputHeight': inputUtils_1.getInputHeightInPx({
            compProps: compProps,
            compLayout: compLayout,
            isMobileView: false,
        }), height: 'auto' });
});
//# sourceMappingURL=TimePicker.js.map